import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=52493d2e&scoped=true&lang=html&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52493d2e",
  null
  
)

export default component.exports